<template>
	<my-dialog :visible.sync="showDialog" title="报销单详情" width="1200px" :close-on-click-modal="false" append-to-body>
		<detail ref="detail"></detail>
		<template #footer>
			<div class="dialog-footer">
				<el-button size="small" @click="closeDialog">关闭</el-button>
			</div>
		</template>
	</my-dialog>
</template>
<script>
import detail from "./detail.vue";
export default {
	props: [],
	data() {
		return {
			showDialog: false
		};
	},
	components: {
		detail
	},
	created() {},
	methods: {
		getDetailDialog(row) {
			this.showDialog = true;
			this.$nextTick(() => {
				this.$refs.detail.getDetail(row);
			});
		},
		closeDialog() {
			this.showDialog = false;
		}
	}
};
</script>
<style scoped lang="scss"></style>
